import { handleMobileRedirect } from "@/auth/utils";
import Vue from "vue";
import VueRouter from "vue-router";

import apps from "./routes/apps";
import contacts from "./routes/contacts";
import engage from "./routes/engage";
import messagingInbox from "./routes/messagingInbox";
import emailInbox from "./routes/emailInbox";
import insights from "./routes/insights";
import secureExports from "./routes/secureExports";
import settings from "./routes/settings";
import pages from "./routes/pages";
import teamChat from "./routes/teamChat";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    // Note that we have split the complete modules and single pages.
    routes: [
        ...apps,
        ...contacts,
        ...engage,
        ...messagingInbox,
        ...emailInbox,
        ...insights,
        ...secureExports,
        ...settings,
        ...pages,
        ...teamChat,
    ],
});

router.beforeEach(handleMobileRedirect);

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
